export default "__VITE_ASSET__B$LEEJmf__"